// @ts-nocheck

import * as Sentry from '@sentry/react';

import { WAPIMethodNames } from '../../constants/api';
import { selectRegulationMessageUuid } from '../../selectors/core/regulationPrimary.selector';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserJwtToken } from '../../selectors/user/userPrimary.selector';
import { RegulationActionTypes } from '../../types/actions/regulation';
import { Licences } from '../../types/common';
import { type Licence } from '../../types/common';
import { makeWapiCall } from '../../utils/api';
import { type HandlerProps } from '../synchronousMiddleware';

const getNamespace = (licence?: Licence) => {
  if (licence === Licences.DE) {
    return 'core/regulation/germany/lugas';
  }

  return null;
};

export const handledActionTypes = [RegulationActionTypes.DISMISS_REALITY_CHECK_MESSAGE];

const regulationMiddlewareHandler = ({ store: { getState }, action }: HandlerProps) => {
  const { type: actionType } = action;

  if (~handledActionTypes.indexOf(actionType)) {
    const state = getState();

    const licence = selectRuntimeLicence(state);
    const jwt = selectUserJwtToken(state);
    const messageUuid = selectRegulationMessageUuid(state);

    if (actionType === RegulationActionTypes.DISMISS_REALITY_CHECK_MESSAGE) {
      if (messageUuid && jwt) {
        const namespace = getNamespace(licence);

        if (namespace) {
          (async () => {
            try {
              const { error } = await makeWapiCall({
                namespace,
                method: WAPIMethodNames.REALTIY_CHECK_CONFIRM_ACTIVITY,
                params: {
                  jwt,
                  activityConfirmationId: messageUuid,
                },
              });

              if (error) {
                Sentry.captureMessage(
                  `Received an error on RealityCheck ${WAPIMethodNames.REALTIY_CHECK_CONFIRM_ACTIVITY} method request`,
                  {
                    extra: {
                      context: 'realityCheck',
                      error,
                    },
                  },
                );
              }
            } catch (error) {
              Sentry.captureException(error, {
                extra: {
                  context: 'realityCheck',
                },
              });
            }
          })();
        }
      }
    }
  }
};

export default regulationMiddlewareHandler;
